import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import BroadcastBoxList from './components/BroadcastBoxList';

const { Cell } = ResponsiveGrid;

const Accounting = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="公播盒列表"
        breadcrumbs={[
          {
            name: '公播管理',
          },
          {
            name: '公播盒列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <BroadcastBoxList />
    </Cell>
  </ResponsiveGrid>
);

export default Accounting;
